var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShoppingCart01Solid = function SvgShoppingCart01Solid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#080808",
    strokeWidth: 1.2,
    d: "M8.4 20a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0Zm10 0a1.4 1.4 0 1 1-2.8 0 1.4 1.4 0 0 1 2.8 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#080808",
    d: "M16 12H8l-.5-1-3-6h15.328a.1.1 0 0 1 .087.15L16 12Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#080808",
    strokeWidth: 1.2,
    d: "M1 3h2.5l1 2m0 0h15.328a.1.1 0 0 1 .087.15L16 12H8l-.5-1m-3-6 3 6M19 16H6.618a1 1 0 0 1-.894-1.447L7.5 11"
  })));
};
export default SvgShoppingCart01Solid;